import { SessionType } from "./session.type";

export const sessionInitialState: SessionType | null = null;
